<template>
  <div>
    <!-- 公募基金 -->
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">基金买入</span>
        <Reback class="row-one-fr" @click.native="reback"></Reback>
      </el-row>
      <!-- 表单 -->
      <el-form v-show="stepDisplay == '1'" :model="rechargeForm" :rules="rechargeFormRules" ref="rechargeFormRef" label-width="96px" class="form-single margin-t20">
        <el-form-item label="基金名称：" class="margin-t30">
          <span class="form-single-sp">{{fundMessage.fundname?fundMessage.fundname+'（'+this.$parameterConfig.p_fundtype[fundMessage.fundtype]+'）':'--'}}</span>
        </el-form-item>
        <el-form-item label="基金公司：" class="margin-t-15">
          <span class="form-single-sp">{{fundMessage.tano?this.$parameterConfig.p_tano[fundMessage.tano]:'--'}}</span>
        </el-form-item>
        <el-form-item label="投资金额：" prop="money" :error="errorMoney">
          <el-input class="inputThree" v-model="rechargeForm.money" @input="rechargeBlur" :placeholder="min+'元起购'" @blur="moneyBlur">
            <span slot="suffix" class="form-single-suf">元</span>
          </el-input>
          <div v-show="scopeShow" class="el-form-item__error" style="width:500px;">{{(isfirstbuyFlag == '1'?'本基金首次申购范围（':'本基金申购范围（') + this.min + '元 ~ ' + this.max + '元）'}}</div>
        </el-form-item>
        <el-form-item label="支付方式：" prop="pay">
          <el-radio-group v-model="rechargeForm.pay" @change="payBlur">
            <!-- 恒宝宝不可认购基金 -->
            <el-radio v-if="fundMessage.status != 1" :label="0">恒宝宝</el-radio>
            <el-radio :label="1">在线支付</el-radio>
            <el-radio :label="2">汇款支付</el-radio>
          </el-radio-group>
          <p v-show="rechargeForm.pay==0 && fundMessage.status != 1" class="form-single-tips">恒宝宝是一款对接货币基金的活期理财产品，首日充值次日确认后即可稳享收益。</p>
          <p v-show="rechargeForm.pay==2" class="form-single-tips">温馨提示：由于汇款支付方式存在银行间转账，期间可能出现转账手续费，具体费用以银行实际扣款为准。</p>
        </el-form-item>
        <!-- 恒宝宝 -->
        <el-form-item v-show="rechargeForm.pay==0 && fundMessage.status != 1">
          <el-input v-model="rechargeForm.input" :disabled="true" class="el-input-disable"></el-input>
        </el-form-item>
        <!-- 银行卡 -->
        <el-form-item class="selectTwo" prop="card">
          <BankCardList :v-model="rechargeForm.card" @slected="getslectedValue" @func="getslectedValue"></BankCardList>
          <span v-if="rechargeForm.card =='' && rechargeForm.pay == '1'" class="form-single-all" @click="$router.push({name:'accountManagement',params:{active:'2'}})">去添加</span>
          <div v-show="rechargeForm.pay == 1 && rechargeForm.card !=''" class="el-form-item__error warnColor">{{'单笔'+SingleDealLimit+'，单日'+SingleDayLimit}}</div>
        </el-form-item>
        <el-form-item label="卡券抵扣：" v-show="rechargeForm.pay!=2">
          <el-radio-group v-model="rechargeForm.kq" @change="couponChange">
            <el-radio :label="1">立减券(可叠加)</el-radio>
            <el-radio :label="2">满减券(每单限用一张)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="margin-t-15" v-show="rechargeForm.pay!=2">
          <ReduceCoupon v-if="rechargeForm.kq==1 && fundMessage !=''" :flag="currencyFlag" @reduceCouponChange="reduceCouponChange"></ReduceCoupon>
          <FullReduceCoupon v-else :flag="currencyFlag" @fullReduceCouponChange="fullReduceCouponChange"></FullReduceCoupon>
          <span class="form-single-all" @click="$router.push({name:'pointsExchange',params:{pathName:'publicPurchaseLists'}})">去兑换</span>
        </el-form-item>
        <el-form-item label="实付金额：" v-show="rechargeForm.pay!=2">
          <span>{{actuallyPaid}}元</span>
          <span class="margin-l50 warnColor">优惠券已抵扣{{reduceMoney}}</span>
          <p v-show="waste" class="form-single-tips rColor">{{wasteText}}</p>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item label="密码：" prop="pass" :error="errorMsg">
          <el-input class="inputThree" type="password" v-model="rechargeForm.pass" autoComplete="new-password" show-password></el-input>
          <el-input style="position:fixed;bottom:-9999px;"></el-input>
        </el-form-item>
        <el-form-item label-width="15px" prop="checked" style="position: relative;">
          <div class="read">
            <el-checkbox class="checkbox-one" v-model="rechargeForm.checked">
            </el-checkbox>
            <div style="display: inline; margin-left: 10px;">请了解基金产品相关内容：
              <a :href="'https://www.myfund.com/contents/mutualfund/'+ fundMessage.fundcode+'.html?type=7'" target="_block" class="tips">产品资料概要、</a>
              <a :href="'https://www.myfund.com/mutualfund/'+ fundMessage.fundcode+'.html?type=6&notice=基金合同'" target="_block" class="aColor">基金合同、</a>
              <a :href="'https://www.myfund.com/mutualfund/'+ fundMessage.fundcode+'.html?type=6&notice=招募说明书'" target="_block" class="aColor">招募说明书、</a>
              <span class="tips" style="margin-left:24px;" @click="agreementClick(fundMessage.fundcode,'customerMaintenanceFee')">客户维护费</span>
              ，并同意
              <!-- 旧风险提示openAcctAgreementRisk"  -->
              <span class="tips" @click="agreementClick(fundMessage.fundcode,'riskDisclosure')">《风险揭示书》</span>
            </div>
          </div>

        </el-form-item>
        <el-form-item>
          <el-button type="normal" @click="onSubmit" :disabled="purchaseText == '处理中...'" style="width:180px;">{{purchaseText}}</el-button>
          <el-button type="cancel" class="fr" @click="reback">返回</el-button>
        </el-form-item>
      </el-form>
      <!-- 充值成功 -->
      <div v-show="stepDisplay == '2'">
        <section v-if="!queryFlag" class="xDetail">
          <ul class="xDetail-stepstwo margin-t10">
            <li class="xDetail-stepstwo-li">
              <span class="xDetail-stepstwo-li-spanone">{{'成功充值'+ parseFloat(rechargeForm.money).toFixed(2)+'元'}}</span>
              <span>{{this.$commonJs.getDateStrHg(confirmTime.transactiondate).slice(5)+'(今天)'}}</span>
              <div class="xDetail-stepstwo-li-img">
                <img src="../../../assets/images/20210316_dg.png" alt="">
                <div class="xDetail-stepstwo-li-img-line"></div>
              </div>
            </li>
            <li class="xDetail-stepstwo-li">
              <span class="xDetail-stepstwo-li-spanone">开始计算收益</span>
              <span>{{(confirmTime.expectcfmdate?confirmTime.expectcfmdate:'--') +'('+(confirmTime.expectcfmworkday?confirmTime.expectcfmworkday:'--') +')'}}</span>
              <div class="xDetail-stepstwo-li-img">
                <img src="../../../assets/images/time.png" alt="">
                <div class="xDetail-stepstwo-li-img-line"></div>
              </div>
            </li>
            <li class="xDetail-stepstwo-li">
              <span class="xDetail-stepstwo-li-spanone">查看收益</span>
              <span>{{(confirmTime.firstpftdate?confirmTime.firstpftdate:'--') +'('+(confirmTime.firstpftworkday?confirmTime.firstpftworkday:'--') +')'}}</span>
              <div class="xDetail-stepstwo-li-img">
                <img src="../../../assets/images/20210316_sy.png" alt="">
              </div>
            </li>
          </ul>
        </section>
        <!-- 详情 -->
        <div class="trade-records">
          <div class="trade-records-fl">
            <!-- 查询中 -->
            <div v-if="queryFlag">
              <img src="../../../assets/images/hbb/query.png" alt="" width="40">
              <p class="aColor margin-t10">支付结果查询中</p>
              <p>您可稍后从交易记录中查看</p>
            </div>
            <!-- 查询完 -->
            <div v-else>
              <img src="../../../assets/images/hbb/bigRight_230210309.png" alt="" width="40">
              <p class="aColor margin-t10">申请已受理</p>
              <p>{{successMessage.bankacctdate?this.$commonJs.getDateStrHz(successMessage.bankacctdate.replace(/-/g,'')):''}}</p>
            </div>
          </div>
          <div class="trade-records-shu"></div>
          <ul class="trade-records-ul1">
            <li><span>交易编号：</span><span>{{comappsheetno}}</span></li>
            <li><span>产品名称：</span><span>{{fundMessage.fundname}}</span></li>
            <li><span>交易类型：</span><span>买入</span></li>
            <li><span>申请时间：</span><span>{{successMessage.bankacctdate?this.$commonJs.getDateStrHz(successMessage.bankacctdate.replace(/-/g,'')):this.$commonJs.getDateStrHg(successMessage.operdate)}}</span></li>
            <li><span>申请金额：</span><span>{{parseFloat(rechargeForm.money).toFixed(2)+'元'}}</span></li>
            <li><span>优惠券抵扣金额：</span><span>{{reduceMoney==0?'0.00元':reduceMoney.toFixed(2)+'元'}}</span></li>
            <li><span>支付方式：</span><span>{{payMethod}}</span></li>
          </ul>
        </div>
        <div class="trade-records">
          <div class="trade-records-fl">
            <img src="../../../assets/images/hbb/jsj_20210309.png" alt="" width="40">
            <p class="aColor margin-t10">待确认</p>
            <p class="aColor">开始计算收益</p>
          </div>
          <div class="trade-records-shu1"></div>
          <ul class="trade-records-ul2">
            <li>交易状态：确认中</li>
            <li>{{'交易金额：'+ parseFloat(rechargeForm.money).toFixed(2)+'元'}}</li>
          </ul>
        </div>
        <div class="text-center margin-b30">
          <el-button v-if="!queryFlag" type="normal" @click="reback">确定</el-button>
        </div>
      </div>
      <!-- 充值失败 -->
      <div v-show="stepDisplay == '3'" class="recharge_error">
        <section class="xDetail">
          <div class="xDetail-icon">
            <img src="../../../assets/images/hbb/error_20210309.png" width="40" alt="">
          </div>
          <p class="xDetail-title rColor">充值失败</p>
          <hr class="xDetail-hr">
          <ul class="xDetail-ul">
            <li class="xDetail-ul-li"><span>失败原因：</span><span>{{wrongReason}}</span></li>
          </ul>
          <hr class="xDetail-hr">
          <div class="xDetail-footer margin-b30">
            <el-button type="normal" @click="reback">确定</el-button>
          </div>
        </section>
      </div>
    </div>
    <!-- 完善信息 -->
    <Perfect></Perfect>
    <!-- 风险测评 -->
    <RiskTips @func="getFunc"></RiskTips>
    <!-- 签约新渠道 -->
    <!-- <el-dialog class="dialog-single-three" :visible.sync="dialogVisable1" :show-close="false" :close-on-click-modal="false">
      <div class="dialog-single-three-p">提示</div>
      <p class="instruction-li-con margin-t20">您可签约新支付渠道，新渠道单笔单日限额较当前渠道有大幅提升。也可稍后在【我的】-【账户管理】-【银行卡管理】自主签约。</p>
      <div class="margin-t20">
        <el-button type="back" style="width:154px;" @click="dialogVisable1 = false">暂不签约</el-button>
        <el-button type="normal" style="width:154px;" @click="notHfSigned">签约新渠道</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    const isNum = (rule, value, callback) => {
      const ret = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value < this.min - 0) {
        callback(new Error('最低买入金额是' + this.min + '元，请重新填写！'))
      } else if ((this.actuallyPaid > parseFloat(this.hbbavailbal)) && this.rechargeForm.pay == 0) {
        callback(new Error('恒宝宝账户可用余额不足！'))
      } else if ((value > parseFloat(this.SingleDealLimit)) && this.rechargeForm.pay == 1) {
        callback(new Error('您输入的金额超过银行卡单笔限额！'))
      } else if (!ret.test(value)) {
        callback(new Error('买入金额小数点位数不应超过2位，请重新填写！'))
      } else {
        callback()
      }
    }
    return {
      dialogVisable1: false,//汇付签约新渠道
      currencyFlag: false,//是否为货币
      // 表单
      rechargeForm: {
        name: '',
        company: '',
        input: '恒宝宝可用金额：0.00元',
        money: '',
        pay: 0,
        card: '',
        kq: 1,
        pass: '',
        checked: false,
      },
      rechargeFormRules: {
        money: [
          { required: true, message: '请输入购买金额', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' }
        ],
        card: [
          { required: true, message: '请选择银行卡', trigger: 'change' },
        ],
        checked: [
          { required: true, trigger: 'blur' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      errorMsg: '',//密码验证错误信息提示
      errorMoney: '',

      actuallyPaid: 0, // 实付金额
      waste: false, // 浪费提醒
      wasteText: '',
      reduceMoney: 0,
      minFull: '',
      // 充值成功
      successMessage: '',
      stepDisplay: '1',
      successDate: {

      },
      confirmTime: '',
      // 下单获取参数
      comappsheetno: '',//单号
      liqdate: '',//购买结算日期
      successFlag: false,
      purchaseText: '确认付款',
      wrongReason: '',
      payMethod: '--',
      channelid: '',
      moneyaccount: '',
      depositacct: '',
      paycenterid: '',
      ticketidStr: '',// 优惠券id(,隔开)
      // 跳转页面信息
      fundMessage: '',
      fundTransmit: '',
      min: '',
      max: '',
      isfirstbuyFlag: '',
      scopeShow: true,
      //恒宝宝充值参数
      transactionaccountid: '',
      targetsharetype: '',
      hbbavailbal: '0.00',
      // 限额
      SingleDealLimit: '',
      SingleDayLimit: '',
      // 汇付
      queryFlag: false,
      time: '',//定时器
    }
  },
  created () {
    this.fundTransmit = this.$route.params.fundMessage ? this.$route.params.fundMessage : this.$route.params
    this.rechargeForm.money = this.fundTransmit.amount ? this.fundTransmit.amount : ''
    if (window.sessionStorage.getItem('deal') != null) {
      this.SingleDealLimit = window.sessionStorage.getItem('deal')
    }
    if (window.sessionStorage.getItem('day') != null) {
      this.SingleDayLimit = window.sessionStorage.getItem('day')
    }
  },
  mounted () {
    this.getFundListone()//基金信息
    this.getRemit()
    this.getHbb()
    this.getShareType()
  },
  methods: {
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    // 充值金额改变
    rechargeBlur (val) {
      if (this.rechargeForm.money < this.minFull && this.rechargeForm.kq == 2) {
        this.waste = true
        this.wasteText = '优惠券无法使用，请查看最低使用金额！'
      } else {
        if (this.rechargeForm.money < this.reduceMoney) {
          this.waste = true
          this.wasteText = '优惠券无法使用，请查看最低使用金额！'
          this.actuallyPaid = 0
        } else if (this.rechargeForm.money == this.reduceMoney && this.rechargeForm.pay == 0 && this.rechargeForm.money != '') {
          this.rechargeForm.pay = 1
          this.waste = false
          this.$message.warning('实付金额为0，已切换到在线支付')
          this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
        } else {
          this.waste = false
          this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
        }
      }
    },
    reback () {
      const path = this.$route.params.pathName
      path != null ? this.$router.push({ name: path }) : this.$router.push({ name: 'myAssets' })
    },
    //银行卡状态改变 选中值
    getslectedValue (val) {
      this.rechargeForm.card = val
      this.channelid = val.split('-')[1]
      this.moneyaccount = val.split('-')[0]
      this.depositacct = val.split('-')[2]
      // 限额
      this.SingleDealLimit = val.split('-')[3]
      this.SingleDayLimit = val.split('-')[4]
      window.sessionStorage.setItem('deal', val.split('-')[3])
      window.sessionStorage.setItem('day', val.split('-')[4])
      // 路由支付
      this.paycenterid = val.split('-')[5]
      if (this.rechargeForm.pay == 0) {
        this.getHbb()
      }
    },
    //立减券
    reduceCouponChange (val) {
      // console.log(val);
      this.reduceMoney = 0
      this.ticketidStr = ''
      val.forEach(item => {
        this.reduceMoney += item.split(',')[1].split('元')[0] - 0
        this.ticketidStr += item.split(',')[0] + ','
      })
      // console.log(this.reduceMoney)
      if (this.rechargeForm.money < this.reduceMoney) {
        this.waste = true
        this.wasteText = '使用优惠券造成金额浪费啦！'
        this.actuallyPaid = 0
      } else if (this.rechargeForm.money == this.reduceMoney && this.rechargeForm.pay == 0 && this.rechargeForm.money != '') {
        this.rechargeForm.pay = 1
        this.waste = false
        this.$message.warning('实付金额为0，已切换到在线支付')
        this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
      } else {
        this.waste = false
        this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
      }
      // console.log(this.reduceMoney, this.ticketidStr);
    },
    // 满减券
    fullReduceCouponChange (val) {
      // console.log(val);
      this.reduceMoney = val.split(',')[1].split('减')[1] - 0
      this.ticketidStr = val.split(',')[0] + ','
      this.minFull = val.split(',')[1].split('减')[0].split('满')[1] - 0
      if (this.rechargeForm.money < this.minFull) {
        this.waste = true
        this.wasteText = '优惠券无法使用，请查看最低使用金额！'
      } else {
        if (this.rechargeForm.money < this.reduceMoney) {
          this.waste = true
          this.wasteText = '使用优惠券造成金额浪费啦！'
          this.actuallyPaid = 0
        } else {
          this.waste = false
          this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
        }
      }
    },
    couponChange () {
      this.reduceMoney = 0
      this.actuallyPaid = this.rechargeForm.money
      this.ticketidStr = ''
      this.waste = false
    },
    // 银行卡购买状态--后期不用删掉
    async tradeState (fundCode) {
      const res = await this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=getFundStatus&fundCode=' + fundCode)
      return res.data.Code
    },
    // 判断汇款
    getRemit () {
      this.$http.post(this.$apiPath.getMyHKBankList, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        const result = res.data.data
        // console.log(res);
        if (result.bankList == null) {
          this.$message.error('您还没有完成汇款交易预开户')
        }
      })
    },
    // 恒宝宝买基金下单
    getHbbPlaceOrder () {
      this.$http.post(this.$apiPath.sellChangeBuynew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        passwd: this.$des.enString(this.rechargeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        fundcode: '162206',//赎回基金
        vastredeemflag: '0',
        applicationamount: this.rechargeForm.money,
        sharetype: 'A',//固定传A
        channelid: this.channelid,//传非恒宝宝的
        moneyaccount: '',//可传空 this.moneyaccount
        targetfundcode: this.fundTransmit.fundcode,//申购基金
        targetsharetype: 'A',//收费方式旧this.targetsharetype  固定传A
        fundtype: this.fundMessage.fundtype,//非恒宝宝
        tano: '22',// 恒宝宝的
        ticketamount: this.reduceMoney,
        ticketids: this.ticketidStr.slice(0, -1),
        transactionaccountid: this.transactionaccountid,//银行卡信息中获取
        appnew: 1,//新个人中心标志
        deviceId: '',
        fundstatus: '',//可传空
      }).then(res => {
        // console.log(res);
        if (res.data.code == "10000005") {
          // 密码输入错误
          this.purchaseText = '确认购买'
          this.errorMsg = res.data.message
        } else if (res.data.code == "9999") {
          // 操作频繁
          this.purchaseText = '确认购买'
          this.errorMsg = res.data.message
        } else if (res.data.code == "2004") {
          // 假期暂停
          this.purchaseText = '确认购买'
          this.errorMsg = res.data.message
        } else if (res.data.code == "200") {
          this.comappsheetno = res.data.data.appsheetserialno
          this.liqdate = res.data.data.liqdate
          this.stepDisplay = '2'
          this.successMessage = res.data.data
          // console.log(this.successMessage);
          this.getTime()
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 5,
            fundname: this.fundMessage.fundname,
            money: this.actuallyPaid,
            dtDate: "",
            fundname2: ""
          })
        } else {
          this.stepDisplay = '3'
          this.wrongReason = (res.data.data.msg != "undefined" ? res.data.data.msg : res.data.message)
        }
      }).catch(err => { })

    },
    // 基金下单
    async getPlaceOrder () {
      this.errorMsg = ''
      await this.$http.post(this.$apiPath.buyFundStepnewDES, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        passwd: this.$des.enString(this.rechargeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        fundcode: this.fundTransmit.fundcode,//
        applicationamount: this.rechargeForm.money,//申请金额（不是实付）
        fundtype: this.fundMessage.fundtype,//
        fundstatus: this.fundMessage.status == 1 ? 20 : 22,//
        sharetype: this.fundMessage.shareclasses,//
        channelid: this.channelid,
        tano: this.fundMessage.tano,//
        moneyaccount: this.moneyaccount,
        buyflag: "1",//银行卡买
        appuuid: "",
        ticketamount: this.reduceMoney,
        paytype: this.rechargeForm.pay,
        ticketids: this.ticketidStr.slice(0, -1),
        appnew: 1,//新个人中心标志
        deviceId: '',
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          if (this.rechargeForm.pay == 2) {//汇款
            this.$router.push({
              name: 'remitMoneySuccess',
              params: {
                card: this.channelid,
                name: 'publicPurchaseLists',
                message: this.fundMessage,
                money: this.rechargeForm.money
              }
            })
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 20,
              fundname: this.fundMessage.fundname,
              money: this.rechargeForm.money,
              dtDate: "",
              fundname2: ""
            })
          } else {//在线
            const result = res.data.data
            if (result) {
              this.comappsheetno = result.appsheetserialno
              this.liqdate = result.liqdate
              this.successFlag = true
              this.getHfPay()
            }
          }
        } else if (res.data.code == "9999") {
          this.purchaseText = '确认购买'
          // this.errorMsg = '操作频繁，请稍后再试'
          this.errorMsg = res.data.message  //23.11.16由于新发基金部分处于募集阶段暂时不能购买，后端添加提示由前端显示在页面中
        } else if (res.data.code == "500") {
          this.purchaseText = '确认购买'
          this.errorMsg = res.data.message + '，请联系工作人员400-818-8000'
        } else {
          this.purchaseText = '确认购买'
          if (res.data.data) {
            this.errorMsg = res.data.data.msg
          } else {
            this.errorMsg = res.data.message
          }
        }
      }).catch(err => { })
    },
    // 富友基金支付----后期不用删掉
    async getPay () {
      if (this.successFlag) {
        await this.$http.post(this.$apiPath.readyPayStepnew, {
          appsheetserialno: this.comappsheetno,
          fundcode: this.fundTransmit.fundcode,//
          tano: this.fundMessage.tano,//
          channelid: this.channelid,
          moneyaccount: this.moneyaccount,
          appuuid: "",
          fundtype: this.fundMessage.fundtype,
          deviceId: "",
          applicationamount: this.rechargeForm.money,//申请金额（不是实付）
          fundstatus: this.fundMessage.status == 1 ? 20 : 22,//
          sessionId: this.$commonJs.getCookie('sessionid'),
          passwd: this.$des.enString(this.rechargeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
          fundname: this.fundMessage.fundname,
          liqdate: this.liqdate,
          appnew: 1,//新个人中心标志
        }).then(res => {
          // console.log(res);
          if (res.data.data.code == "0000" && res.data.data.forward == "socketPay") {//成功
            this.stepDisplay = '2'
            this.successMessage = res.data.data
            this.getTime()
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 1,
              fundname: this.fundMessage.fundname,
              money: this.actuallyPaid,
              dtDate: "",
              fundname2: ""
            })
            this.dialogVisable1 = true// 签约新渠道弹框
          } else if (res.data.data.readyPayMsg.code == "100085" || res.data.data.readyPayMsg.code == "100086" || res.data.data.readyPayMsg.msg == "尚未进行快捷签约") {
            // 未签约
            this.notHfSigned()
          } else if (res.data.data.code == "-990016001") {
            if (res.data.data.msg == "余额不足") {
              this.wrongReason = "扣款失败，请检查银行卡余额！"
            } else if (res.data.data.msg == "单笔金额超限") {
              this.wrongReason = "单笔金额超限！"
            } else {
              this.wrongReason = res.data.data.msg
            }
          } else {
            this.stepDisplay = '3'
            this.wrongReason = (res.data.data.readyPayMsg != "undefined" ? res.data.data.readyPayMsg.msg : res.data.message)
          }
        })
      }
    },
    // 基金支付
    async getHfPay () {
      if (this.successFlag) {
        await this.$http.post(this.$apiPath.readyPay, {
          fundtype: this.fundMessage.fundtype,
          fundcode: this.fundTransmit.fundcode,
          fundname: this.fundMessage.fundname,
          sessionId: this.$commonJs.getCookie('sessionid'),
          deviceId: "",
          appsheetserialno: this.comappsheetno,
          moneyaccount: this.moneyaccount,  //银行卡moneyaccount
          applicationamount: this.rechargeForm.money,//申请金额（不是实付）
          passwd: this.$des.enString(this.rechargeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
          liqdate: this.liqdate,
          tano: this.fundMessage.tano,
          channelid: this.channelid,  //银行卡channelid
          paycenterid: this.paycenterid,  //银行卡paycenterid
          fundstatus: this.fundMessage.status == 1 ? 20 : 22,
          appnew: 1,//新个人中心标志
        }).then(res => {
          // console.log('支付',res);
          if (res.data.code == "FS9") {// 汇付查询
            this.getHfResult()
          } else if (res.data.code == "200") {// 富友成功，用优惠券实付金额为0 成功
            this.successMessage = res.data.data
            this.getTime()
            this.stepDisplay = '2'
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 1,
              fundname: this.fundMessage.fundname,
              money: this.actuallyPaid,
              dtDate: "",
              fundname2: ""
            })
          } else if (res.data.code == "2222") {//重新签约
            this.notHfSigned()
          } else {
            this.stepDisplay = '3'
            this.wrongReason = res.data.message
          }
        }).catch(err => { })
        // 旧
        // await this.$http.post(this.$apiPath.hfreadyPay, {
        //   appsheetserialno: this.comappsheetno,
        //   fundcode: this.fundTransmit.fundcode,//
        //   fundtype: this.fundMessage.fundtype,
        //   tano: this.fundMessage.tano,//
        //   channelid: this.channelid,
        //   moneyaccount: this.moneyaccount,
        //   deviceId: "",
        //   applicationamount: this.rechargeForm.money,//申请金额（不是实付）
        //   fundstatus: this.fundMessage.status == 1 ? 20 : 22,//
        //   sessionId: this.$commonJs.getCookie('sessionid'),
        //   fundname: this.fundMessage.fundname,
        //   liqdate: this.liqdate,
        //   appnew: 1,//新个人中心标志
        // }).then(res => {
        //   // console.log(res);
        //   if (res.data.code == "FS9") {//成功
        //     this.getHfResult()
        //   } else if (res.data.code == "200") {//用优惠券实付金额为0 成功
        //     this.successMessage = res.data.data
        //     this.getTime()
        //     this.stepDisplay = '2'
        //     // 推送消息
        //     this.$store.dispatch({
        //       type: "pushNews",
        //       index: 1,
        //       fundname: this.fundMessage.fundname,
        //       money: this.actuallyPaid,
        //       dtDate: "",
        //       fundname2: ""
        //     })
        //   } else if (res.data.code == "2222") {//重新签约
        //     this.notHfSigned()
        //   } else {
        //     this.wrongReason = res.data.message
        //     this.purchaseText = '确认购买'
        //   }
        // }).catch(err => { })
      }
    },
    // 汇付查询结果
    getHfResult () {
      this.$http.post(this.$apiPath.hfquery, {
        appsheetserialno: this.comappsheetno
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {//成功
          this.queryFlag = false
          this.successMessage = res.data.data.tradeinfo
          this.getTime()
          this.stepDisplay = '2'
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 1,
            fundname: this.fundMessage.fundname,
            money: this.actuallyPaid,
            dtDate: "",
            fundname2: ""
          })
          clearInterval(this.time)
        } else if (res.data.code == "FS9") {//支付结果查询中
          this.queryFlag = true
          this.stepDisplay = '2'
          this.time = setInterval(() => {
            this.getHfResult()
          }, 2000);
        } else {
          this.queryFlag = false
          this.stepDisplay = '3'
          this.wrongReason = res.data.message
          clearInterval(this.time)
        }
      }).catch(err => { })
    },
    // 确认付款
    onSubmit () {
      this.moneyBlur()
      if (this.rechargeForm.checked == false) {
        this.$message.error('请仔细阅读风险提示与产品资料')
      } else {
        this.$refs.rechargeFormRef.validate(valid => {
          if (!valid || this.waste) return
          this.purchaseText = '处理中...'
          if (this.rechargeForm.pay == 0) {//恒宝宝
            this.getHbbPlaceOrder()
          } else if (this.rechargeForm.pay == 1) {//在线
            this.getPlaceOrder()
          } else {//汇款
            this.reduceMoney = 0
            this.ticketidStr = ''
            this.getPlaceOrder()
          }
        })
      }
    },
    // 未签约-------后期可删掉
    notSigned () {
      var pass = this.$des.enString(this.rechargeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      if (pass == this.$commonJs.getCookie('Password')) {
        this.notHfSigned()
      } else {
        this.purchaseText = '确认付款'
        this.errorMsg = '密码输入错误'
      }
    },
    // 未签约跳转
    notHfSigned () {
      this.$router.push({
        name: 'bankCardVerificationHf',
        params: {
          name: 'publicBuy',
          fundMessage: this.fundMessage,//基金信息
          cardMessage: {//银行卡信息
            depositacct: this.rechargeForm.card.split('-')[2],
            moneyaccount: this.rechargeForm.card.split('-')[0],
            paycenterid: this.rechargeForm.card.split('-')[5],
            channelid: this.rechargeForm.card.split('-')[1],
          }
        }
      })
    },
    // 确认中时间
    getTime () {
      this.$http.post(this.$apiPath.hbbMessageInfo, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: this.comappsheetno
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.confirmTime = res.data.data.hbbTradeInfo[0]
        if (this.rechargeForm.pay == 0) {
          this.payMethod = '恒宝宝'
        } else if (this.rechargeForm.pay == 1) {
          this.payMethod = '银行卡(*' + this.confirmTime.depositacct.substr(this.confirmTime.depositacct.length - 4) + ')'
        }
        //console.log(this.confirmTime);
      }).catch(err => { })
    },
    // 获取单只基金信息
    async getFundListone () {
      await this.$http.post(this.$apiPath.fundListone, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundTransmit.fundcode
      }).then(res => {
        // console.log('基金信息', res);
        if (res.data.code == '200') {
          const result = res.data.data
          if (result.length > 0) {
            this.fundMessage = result[0]
            if (this.fundMessage.status == 1) {
              this.rechargeForm.pay = 1
            }
            this.currencyFlag = this.fundMessage.fundtype == '2' ? true : false
          }
        }
      })
      this.getFirst()
    },
    getFirst () {
      this.$http.post(this.$apiPath.isfirstbuy, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        tano: this.fundMessage.tano,
        fundcode: this.fundTransmit.fundcode,
        sharetype: this.fundMessage.shareclasses
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        // 是否是第一次购买基金 1首次，0复购
        this.isfirstbuyFlag = res.data.data.isfirstbuy[0].isfirstbuy
        // console.log(res);
        if (this.isfirstbuyFlag == "1") {//首次
          if (this.fundMessage.status == "1") {//认购20
            this.min = this.fundMessage.first_per_min_20
            this.max = this.fundMessage.first_per_max_20
          } else {//申购22
            this.min = this.fundMessage.first_per_min_22
            this.max = this.fundMessage.first_per_max_22
          }
        } else {
          if (this.fundMessage.status == "1") {//认购20
            this.min = this.fundMessage.con_per_min_20
            this.max = this.fundMessage.con_per_max_20
          } else {//申购22
            this.min = this.fundMessage.con_per_min_22
            this.max = this.fundMessage.con_per_max_22
          }
        }

      }).catch(err => { })
    },
    getHbb () {//恒宝宝余额
      this.$http.post(this.$apiPath.getHbbbank, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.bankList.length > 0) {
          this.hbbavailbal = '0.00'
          res.data.data.bankList.forEach(item => {
            if (this.channelid == item.channelid) {
              this.hbbavailbal = item.availbal
              this.transactionaccountid = item.transactionaccountid
            }
          })
          this.rechargeForm.input = '恒宝宝可用金额：' + this.hbbavailbal + '元'
        } else {
          this.hbbavailbal = '0.00'
        }
        // console.log(res);
      }).catch(err => { })
    },
    // 基金收费方式
    getShareType () {
      this.$http.post(this.$apiPath.shareType, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundTransmit.fundcode,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.targetsharetype = res.data.data.sharetype
        // console.log('收费方式', this.targetsharetype);
      }).catch(err => { })
    },
    moneyBlur () {
      this.$refs.rechargeFormRef.validateField('money', (err) => {
        this.scopeShow = err != '' ? false : true
      })
    },
    payBlur () {
      this.moneyBlur()
      if (this.rechargeForm.money == this.reduceMoney && this.rechargeForm.pay == 0 && this.rechargeForm.money != '') {
        this.rechargeForm.pay = 1
        this.$message.warning('实付金额为0，已切换到在线支付')
        this.actuallyPaid = parseFloat(this.rechargeForm.money - this.reduceMoney).toFixed(2)
      }
    },
    // 风险揭示书和客户维护费
    agreementClick (val, fname) {
      const { href } = this.$router.resolve({
        name: fname,
        query: {
          fundcode: val
        }
      })
      window.open(href, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
// 读
.read {
  width: 457px;
  line-height: 24px;
}
.tips {
  color: @color;
  cursor: pointer;
}
</style>
